module.exports = __webpack_public_path__ + "static/img/dog@2x.f5d9cc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/dog@2x.png
// module id = J1l1
// module chunks = 2